import { Box, Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { DrawerWidget, ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allMatriculasAction,
  setActivoMatriculasAction,
} from './MatriculasAction';
import FiltrosMatriculasComponent from './components/FiltrosMatriculas';
import FormMatriculas from './components/FormMatriculas';
import ListadoMatriculas from './components/ListadoMatriculas';

const MatriculasView = () => {
  const dispatch = Redux.useDispatch();

  const matriculasStore = Redux.useSelector((state) => state.matriculas);

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [isFiltros, setIsFiltros] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid
        item
        md={12}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Box>
          <BotonComponent
            click={async () => {
              await setActivoMatriculasAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            addIcon
            mr={2}
          />
          <BotonComponent
            click={async () => {
              await setActivoMatriculasAction(dispatch, null);
              await allMatriculasAction(dispatch, matriculasStore.params);
            }}
            disabled={
              matriculasStore.loadingAll || matriculasStore.all.length === 0
            }
            white
            refreshIcon
            text={matriculasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
          />
        </Box>

        <BotonComponent
          text={`FILTROS ${isFiltros ? 'ACTIVO' : ''}`}
          filterIcon
          click={() => setIsFiltros(!isFiltros)}
          white={!isFiltros}
          blue={isFiltros}
          me={2}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoMatriculas setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <DrawerWidget open={isFiltros} onClose={(val) => setIsFiltros(val)}>
        <FiltrosMatriculasComponent />
      </DrawerWidget>
      <ModalComponent
        id="modalFormMatriculas"
        title={`${
          matriculasStore.activo
            ? `Editar matrícula: ${matriculasStore.activo.nroRegistro}`
            : 'Nueva matrícula'
        }`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormMatriculas
          activo={matriculasStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default MatriculasView;
